module.exports = __webpack_public_path__ + "static/media/icon-mail-contact.e53edd13.svg";